import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { AppService, ProductTranslations } from '../../services/app.service';
import { Product, ProductsService } from '../../services/products.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ProductEditEvent, ProductEditType, ProductListService } from '../product-list/product-list.service';

export type ProductFormControlType = {
    optional: FormControl<boolean>;
};

type EditableProduct = Product & { formGroup: FormGroup<ProductFormControlType> };

@Component({
    selector: 'app-product-table',
    templateUrl: './product-table.component.html',
    styleUrls: ['./product-table.component.scss'],
})
export class ProductTableComponent implements OnInit {
    constructor(
        private appService: AppService,
        public productService: ProductsService,
        private productListService: ProductListService
    ) {}

    @ViewChild(MatSort)
    public sort: MatSort;

    @Input()
    public dataSource: any;

    @Input()
    public isExternalApp = false;

    public columnsToDisplay: string[];

    public ngOnInit() {
        if (this.dataSource) {
            this.dataSource.sort = this.sort;
        }
        this.columnsToDisplay = [
            'product-group',
            'image',
            'partNumber',
            'quantity',
            'description',
            'materialGroup',
            'optional',
        ];

        this.productListService.clearEdits();
    }

    public chooseTranslation(productTranslations?: ProductTranslations) {
        return this.appService.chooseTranslation(productTranslations);
    }

    public setOptional(product: EditableProduct) {
        const optional = product.formGroup.controls.optional.value;
        this.editProduct({ type: ProductEditType.optional, productId: product.material, newValue: optional });
    }

    private editProduct(...events: ProductEditEvent[]) {
        const current = this.productListService.productListEdits$.value || [];
        this.productListService.productListEdits$.next([...current, ...events]);
    }
}
